const pwa = {
  installTitle: "Установить GAM CC",
  installDescription: "Быстрый доступ с главного экрана — работает и офлайн",
  installButton: "Установить",
  iosShareGuide: "Нажмите кнопку «Поделиться», затем «На экран Домой»",
  offlineTitle: "Нет подключения к интернету",
  offlineDescription: "Эта страница недоступна офлайн. Проверьте интернет и повторите попытку.",
  offlineRetry: "Повторить",
  pushEnable: "Включить уведомления",
  pushDisable: "Отключить уведомления",
  pushEnabled: "Уведомления включены",
  pushNotSupported: "Уведомления не поддерживаются в этом браузере",
  pushBlocked: "Уведомления заблокированы — разрешите в настройках браузера",
  installationStatus: "Статус установки",
  installedStandalone: "Установлено (Standalone)",
  runningInBrowser: "Работает в браузере",
  installApp: "Установить приложение",
  iosInstallHint: "В Safari: нажмите Поделиться → На экран «Домой»",
  appName: "Название приложения",
  appDescription: "Описание",
  pushNotifications: "Push-уведомления",
  pushPermission: "Разрешение на уведомления",
  permGranted: "Разрешено",
  permDenied: "Отклонено",
  permPrompt: "Ожидание",
  permUnsupported: "Не поддерживается",
  enablePush: "Включить уведомления",
  disablePush: "Отключить уведомления",
  sendTestPush: "Отправить тестовое уведомление",
  testPushSent: "Тестовое уведомление отправлено",
  notificationTemplates: "Шаблоны уведомлений",
  templateStatus: "Обновление статуса",
  templateMention: "Упоминание",
  templateDeadline: "Дедлайн",
  templateAi: "Ответ AI",
  templateTitle: "Заголовок",
  templateBody: "Содержание",
  templateVars: "Переменные: {{project}}, {{user}}, {{date}}",
  notifPreferences: "Настройки уведомлений",
  notifWhatsapp: "WhatsApp",
  notifPhone: "Звонки",
  notifSms: "SMS",
  notifEmail: "Почта",
  notifNote: "Заметки",
  notifReminder: "Напоминания",
  notifSync_summary: "Синхронизация",
  cameraScanner: "Камера и сканер",
  cameraPermission: "Разрешение камеры",
  requestCamera: "Запросить разрешение",
  scanQR: "Сканировать QR",
  scanResult: "Результат сканирования",
  takePhoto: "Сделать фото",
  photoPreview: "Предпросмотр",
  clearPhoto: "Очистить",
  contacts: "Контакты",
  contactsSupported: "Поддерживается",
  contactsNotSupported: "Не поддерживается в этом браузере",
  contactsHint: "Contact Picker API доступен только в Chrome Android",
  importContacts: "Импорт контактов",
  contactName: "Имя",
  contactEmail: "Эл. почта",
  contactPhone: "Телефон",
  noContacts: "Контакты не импортированы",
  clearContacts: "Очистить список",
  deviceCapabilities: "Возможности устройства",
  webShare: "Веб-шеринг",
  testShare: "Тест шеринга",
  wakeLock: "Блокировка экрана",
  wakeLockActive: "Экран останется включённым",
  vibration: "Вибрация",
  testVibration: "Тест вибрации",
  geolocation: "Геолокация",
  getLocation: "Получить местоположение",
  badgeApi: "Badge API",
  backgroundSync: "Фоновая синхронизация",
  serviceWorkerStatus: "Service Worker",
  supported: "Поддерживается",
  notSupported: "Не поддерживается",
  active: "Активен",
  inactive: "Неактивен",
  pushAdmin: "Управление подписчиками Push",
  subscriberEmail: "Эл. почта",
  subscriberDate: "Дата подписки",
  subscriberLastActive: "Последняя активность",
  sendToUser: "Отправить",
  sendToAll: "Отправить всем",
  cleanExpired: "Очистить истёкшие",
  cleaning: "Очистка...",
  cleaned: "Очищено",
  noSubscribers: "Нет подписчиков push",
  loading: "Загрузка...",
} as const;
export default pwa;
